module.exports = __webpack_public_path__ + "static/img/5.聖誕鞋盒捐贈.fbf69e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/charitable-activities/5.聖誕鞋盒捐贈.jpg
// module id = 4UPu
// module chunks = 99